import { ApplicationInsights, ITelemetryItem } from "@microsoft/applicationinsights-web";
import { config } from "./config";

declare const __webpack_hash__: string;

function stripUserTokenFromHashInPlace(envelope: ITelemetryItem) {
  const stripHash = (url: string) => {
    const newUrl = new URL(url);
    newUrl.hash = "";
    return newUrl.toString();
  };
  // Library tracks the following
  envelope.data = envelope.data || {};
  if (envelope.baseData) {
    if (envelope.baseData.refUri && envelope.baseData.refUri.indexOf("token") !== -1) {
      envelope.baseData.refUri = stripHash(envelope.baseData.refUri);
      envelope.data.sruh = true;
    }
    if (envelope.baseData.uri && envelope.baseData.uri.indexOf("token") !== -1) {
      envelope.baseData.uri = stripHash(envelope.baseData.uri);
      envelope.data.suih = true;
    }
    if (envelope.baseData.url && envelope.baseData.url.indexOf("token") !== -1) {
      envelope.baseData.url = stripHash(envelope.baseData.url);
      envelope.data.sulh = true;
    }
  }
}

function addApplicationVersionIfExistsInPlace(envelope: ITelemetryItem) {
  try {
    (envelope as any).context = (envelope as any).context || {};
    (envelope as any).context.application = (envelope as any).context.application || {};
    (envelope as any).context.application.build = __webpack_hash__;
  } catch (e) {
    (envelope as any).context.application.build = "no hash available";
  }
}

function removeUserDataFromTackingInPlace(envelope: ITelemetryItem) {
  if (envelope.ext && "user" in envelope.ext) {
    delete envelope.ext.user;
  }
}

function telemetryInitializer(envelope: ITelemetryItem): boolean | void {
  const envType = config.get("type");
  if (envType.indexOf("accessibility") !== -1 || envType.indexOf("integration") !== -1) {
    // do not log automation to app insights
    return false;
  }
  addApplicationVersionIfExistsInPlace(envelope);
  stripUserTokenFromHashInPlace(envelope);
  removeUserDataFromTackingInPlace(envelope);
}

export function setupAppInsights(): ApplicationInsights {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: config.get("instrumentationKey"),
      isCookieUseDisabled: true,
      appId: config.get("clientId"),
      enableCorsCorrelation: true,
      enableAutoRouteTracking: true
    }
  });
  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(telemetryInitializer);
  appInsights.trackPageView();
  return appInsights;
}

export function getLogger(envType: string): ApplicationInsights {
  return envType === "accessibility" || envType === "test"
    ? ({
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackDependencyData: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackEvent: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackPageView: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackPageViewPerformance: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackException: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackTrace: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        trackMetric: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        startTrackPage: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopTrackPage: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        startTrackEvent: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopTrackEvent: () => {}
      } as any)
    : setupAppInsights();
}
